import { AppShell, Box, ScrollArea, useMantineColorScheme, useMantineTheme } from "@mantine/core";
import { useState } from "react";
import { Outlet } from "react-router";
import { useQuantityUnitLabel } from "../../provider/quantity-unit";
import { Footer } from "./Footer/Footer";
import Header from "./Header/Header";
import { NavbarSegmented } from "./Navbar/NavbarSegmented";

function AppShellLayout() {
    const [leftSideVisible, setLeftSideVisible] = useState<boolean>();
    const theme = useMantineTheme();
    const { colorScheme } = useMantineColorScheme();

    // Le quantità a video portano l'unità di misura: le pagine si disegnano quando è nota, e
    // si ridisegnano se viene cambiata dalle impostazioni.
    const quantityUnit = useQuantityUnitLabel();

    return (
        <AppShell
            header={{ height: 60 }}
            footer={{ height: 50 }}
            navbar={{ width: 300, breakpoint: 'sm', collapsed: { mobile: !leftSideVisible } }}
            padding="md" transitionDuration={0}>
            <AppShell.Header>
                <Header toggleLeftSideVisible={setLeftSideVisible} />
            </AppShell.Header>
            <AppShell.Navbar>
                <NavbarSegmented />
            </AppShell.Navbar>
            <AppShell.Main bg={colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[6]}>
                <ScrollArea h={'calc(100vh - 145px)'}>
                    {quantityUnit && <Box key={quantityUnit}><Outlet /></Box>}
                </ScrollArea>
            </AppShell.Main>
            <AppShell.Footer>
                <Footer />
            </AppShell.Footer>
        </AppShell>
    );
}

export default AppShellLayout;